// extracted by mini-css-extract-plugin
export default {"footer":"FooterCentered_footer__hxpgO","inner":"FooterCentered_inner__2OJLj","links":"FooterCentered_links__M70EE"};